import ContactRow from './ContactRow.component';

export * from './ContactRow.component';
export default ContactRow;